import { useCookies } from 'react-cookie';
import { USA, GEOLOCATION_COOKIE } from 'lib/myNewsConstants';

export function useGeoLocation() {
  const [cookies] = useCookies([GEOLOCATION_COOKIE]);
  const geoLocation = cookies[GEOLOCATION_COOKIE];

  return { geoLocation, isUsa: geoLocation === USA };
}
